'use client';

import React from 'react';
import {PopoverProps as Props, instanceType} from './Popover.type';
import {Grow, Popper} from '@mui/material';
import {disableScrollOnPopover} from './Popover.utils';

import cn from './Popover.module.scss';

// monitor created instances for nested use cases (disable scroll)
let instances: instanceType[] = [];

/**
 * render popover content based on visible prop value
 */
export function Popover(props: Props) {
  const [selfId, setId] = React.useState<number>(
    Math.floor(Math.random() * 1000)
  );
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    instances = disableScrollOnPopover(
      {id: selfId, visible: props.visible},
      instances
    );
  }, [props.visible]);

  return (
    <div className={cn.container} ref={ref}>
      <div className={cn.container_wrapper}>{props.children}</div>
      <Popper
        transition
        disablePortal={!props.enablePortal}
        anchorEl={ref.current}
        open={props.visible}
        sx={{
          zIndex: 999,
        }}
        className={`${cn.overlay} ${props.overlayClassName}`}>
        {({TransitionProps}) => (
          <Grow {...TransitionProps} style={{transformOrigin: 'top'}}>
            <div className={`${cn.overlay_content} ${props.className}`}>
              {props.content}
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
